/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { responsiveTextStyle } from '../../utils/responsiveTextStyle';

const styles = StyleSheet.create((pd) => ({
  pageContainer: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
  },
  container: {
    flexGrow: 1,
    padding: pd.ref.space.spacing40.px,
    gap: pd.ref.space.spacing40.px,
  },
  pinInputField: {
    width: pd.ref.space.spacing80.px,
  },
  alternativeSignUp: responsiveTextStyle(
    pd.sys.typescale.body_text_medium,
    pd.sys.typescale.heading_4,
    pd.sys.colour.interactive_link,
  ),
}));

export default styles;
